export const isCigaretteBarProduct = (product) =>
  product?.barProductType === "CIGARETTE";

export const getBarProductTypeLabel = (productOrType) =>
  (typeof productOrType === "string" ? productOrType : productOrType?.barProductType) === "CIGARETTE"
    ? "Cigarette"
    : "Liquor";

export const isLiquorSaleItem = (item) =>
  item?.itemType === "BOTTLE" && item?.barProductType !== "CIGARETTE";

export const isCigaretteSaleItem = (item) =>
  item?.itemType === "BOTTLE" && item?.barProductType === "CIGARETTE";

export const getSaleItemTypeLabel = (item, modes) => {
  if (isCigaretteSaleItem(item)) return "Cigarette";
  if (!isLiquorSaleItem(item)) {
    if (item?.itemType === "BEVERAGE") return "BEVERAGE";
    if (item?.itemType === "FOOD" || item?.itemType === "BITE") return "FOOD";
    if (item?.itemType === "GOODS") return "GOODS";
    return item?.itemType || "RESTAURANT ITEM";
  }
  if (item.bottleSaleMode === modes.MEASURE_180ML) return "180 ML";
  if (item.bottleSaleMode === modes.MEASURE_90ML) return "90 ML";
  return "FULL BOTTLE";
};

export const getBarProductMeasurementLabel = (product) => {
  if (isCigaretteBarProduct(product)) return "Cigarette";
  const container = product?.bottleSize === "TIN" ? "Tin" : "Bottle";
  const volume = product?.volumeMl ? `${product.volumeMl} ML` : "";
  return [container, volume].filter(Boolean).join(" · ");
};
